import { Tooltip as MuiTooltip } from '@mui/material';
import React from 'react';

import { Wrapper } from '@/shared/components/ui/tooltip/tooltip.styled';
import { TTooltipProps } from '@/shared/components/ui/tooltip/tooltip.types';

export const Tooltip: React.FC<TTooltipProps> = ({
  wrapper,
  noMaxWidth,
  textAlign = 'center',
  children,
  clicked: _,
  ...props
}) => {
  return (
    <MuiTooltip
      {...props}
      slotProps={{
        tooltip: {
          sx: {
            maxWidth: noMaxWidth ? 'calc(100vw - 4rem)' : '300px',
            maxHeight: '300px',
            overflow: 'auto',
            margin: '2rem',
            backgroundColor: (theme) => theme.palette.background.tooltip,
            padding: '0.25rem 0.75rem',
            borderRadius: (theme) => theme.shape.tooltipRadius,
            fontSize: (theme) => theme.typography.p7.fontSize,
            fontWeight: (theme) => theme.typography.p7.fontWeight,
            lineHeight: (theme) => theme.typography.p7.lineHeight,
            boxShadow: (theme) => theme.shadow.tooltip,
            color: (theme) => theme.palette.primary.contrastText,
            textWrap: 'balance',
            textAlign,
            '.custom-tag': {
              alignSelf: 'flex-start',
            },
          },
        },
        arrow: {
          sx: {
            color: (theme) => theme.palette.background.tooltip,
            '&::before': {
              borderRadius: (theme) => theme.shape.tooltipArrowRadius,
            },
          },
        },
      }}
    >
      {wrapper ? <Wrapper $wrapper={wrapper}>{children}</Wrapper> : children}
    </MuiTooltip>
  );
};
